import { render, staticRenderFns } from "./ContractMailsNav.vue?vue&type=template&id=3ef36a2a&"
import script from "./ContractMailsNav.vue?vue&type=script&lang=js&"
export * from "./ContractMailsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports